<template>
    <div class="bg-porcelain2 px-5 pt-24 relative">
        <hr class="absolute top-0 inset-x-0 mx-auto max-w-container border-t-8 border-shuttle w-full -mt-1">
        <div class="container mx-auto">
            <gallery-filters  v-model="filterValues" :product-options="filterProducts"
                              :category-options="filterCategories"/>
            <div class="w-100 text-center mb-4" v-if="loading">
                <div class="loader-spinner mx-auto"></div>
            </div>
            <div v-if="loading === false" class="flex sm-down:items-center flex-col sm:flex-row flex-wrap -mx-3">
                <gallery-card v-for="project in projects"
                          :key="project.uid"
                          :project="project"
                />
                <div v-if="projects.length === 0" class="w-100 text-center my-4"><p>Sorry, there were no results for those parameters!</p></div>
            </div>
            <pagination v-on:pageChange="handlePageChange"
                        v-if="loading === false && pageInfo && pageInfo.total_pages > 1" :page-info="pageInfo"/>
        </div>
    </div>
</template>

<script>
    import GalleryCard from './GalleryCard.vue'
    import api from '../../js/api/gallery'
    import GalleryFilters from "./GalleryFilters.vue";
    import Pagination from "../AlluraUI/Pagination.vue";

    export default {
        components: {
            Pagination,
            GalleryFilters,
            GalleryCard
        },
        watch: {
            $route() {
                // this.loadData();
            },
            currentCategory(newVal, oldVal) {
                this.$router.push({
                    name: 'index',
                    query: {
                        category: newVal
                    }
                }).then(() => {
                    this.loadData();
                }).catch(err => {});
            },
            currentProduct(newVal) {
                this.$router.push({
                    name: 'index',
                    query: {
                        product: newVal
                    }
                }).then(() => {
                    this.loadData();
                }).catch(err => {});
            }
        },
        computed: {
            currentCategory() {
                return this.filterValues.category;
            },
            currentProduct() {
                return this.filterValues.product;
            }
        },
        data() {

            let {product, category} = this.$route.query;
            if (!product) {
                product = '*';
            }
            if (!category) {
                category = '*';
            }

            return {
                loading: true,
                projects: [],
                pageInfo: null,

                filterValues: {
                    product: product,
                    category: category
                }
            }
        },
        methods: {
            handleSearchQuerySubmitted() {

            },
            handlePageChange(page) {
                this.$router.push({
                    name: 'index',
                    query: {
                        page: page
                    }
                }).then(() => {
                    this.loadData();
                }).catch(err => {});
            },

            loadData() {
                const {product, category, query, page} = this.$route.query;
                this.loading = true;
                api.getProjects(product, category, page).then((resp) => {
                    this.projects = resp.data.data;
                    this.pageInfo = resp.data.meta.pagination;
                }).finally(() => {
                    this.loading = false
                });
            }
        },
        name: 'GalleryItems',
        created() {
            this.loadData();
        },
        props: {
            filterCategories: Array,
            filterProducts: Array
        }
    }
</script>